import React, { useCallback, useState, useEffect } from "react";

// redux
import { connect } from "react-redux";

// themes
import { Theme1 } from "./theme";

// APIs
import { getCategoriesTree } from "utlis/Apis/Categories_API";

// app messages
import {
	UNKNOWN_ERROR_OCCURED,
	ERROR_WHILE__NAME,
} from "utlis/AppMessages/AppMessages";

function HeaderComp(props) {
	// props
	const { globalAppTheme, commonToken } = props

	// states
	const [categories, setCategories] = useState([]);
	const [categoriesLoading, setCategoriesLoading] = useState(false);

	// FUNCTIONS
	// get categories list
	const getCategoriesList = useCallback(() => {
		// enable categories list loading
		setCategoriesLoading(true);

		// getting categories tree
		getCategoriesTree(commonToken ?? "").then((res) => {
			// disabling categories list loading
			setCategoriesLoading(false);

			const catsData = res?.data;

			// if request is success
			if (catsData?.success) {
				// settings categories
				setCategories(catsData.data);
			}

			// if request is not succeed
			if (catsData?.error) {
				console.log(UNKNOWN_ERROR_OCCURED, res);
			}
		}).catch((err) => {
			console.log(`${ERROR_WHILE__NAME} getCategoriesTree `, err.message);
		});
	}, [commonToken]);

	useEffect(() => {
		getCategoriesList();
	}, [getCategoriesList]);

	return (
		<React.Fragment>
			{
				globalAppTheme === "theme1" &&
				<Theme1 categories={categories} />
			}
		</React.Fragment>
	);
}

const getDataFromStore = (state) => {
	return {
		currentUser: state.auth.currentUser,
		commonToken: state.auth.commonToken,
		globalAppTheme: state.common.globalAppTheme,
	};
};

export default connect(getDataFromStore, null)(HeaderComp);
